export default {
  // 实时变化Signature
  makeSignature(params, reqTime) {
    let paramsKeys = Object.keys(params).sort();
    let paramsStr = '';
    for (let paramsKey of paramsKeys) {
      paramsStr += `${paramsKey}=${params[paramsKey]}&`;
    }
    return $.md5(paramsStr + reqTime);
  },

  // 获取网站来源
  getUrlParam(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  // gTag
  gtag() {
    dataLayer.push(arguments);
  },
  // 时间
  tsformat(ts) {
    const time = new Date(String(ts).length === 13 ? ts : ts * 1000);
    return `${time.getFullYear()}/${time.getMonth() + 1}/${time.getDate()}`;
  },

  // style函数
  handleScale() {
    let winWidth = $(window).width();
    let winHeight = $(window).height();
    const contScale = Math.min(((winWidth / winHeight) / (1920 / 1080)), ((winHeight / winWidth) / (1080 / 1920)));
    return {
      transform: "matrix(" + contScale + ", 0, 0, " + contScale + ", 0, 0)",
    };
  },
  // 宽高比
  handleVideoSize() {
    console.log('1111  handleVideoSize  11111')
    const scalex = $(window).width() / 1920;
    const scaley = $(window).height() / 1080;
    const vscale = Math.max(scalex, scaley);
    const vwidth = 1920 * vscale;
    const vheight = 1080 * vscale;

    // $set('width', vwidth + 'px', 'height', vheight + 'px', marginLeft + (-vwidth / 2) + 'px')
    console.log('1111', vheight)
    return {
      width: vwidth + 'px',
      height: vheight + 'px',
      marginLeft: (-vwidth / 2) + 'px',
    };
  },
  // 统一链接

  goShare(code) {
    switch (code) {

      case 'gp':
        window.open(`https://play.google.com/store/apps/details?id=com.ujoy.doragenai`, '_blank');
        break;
      case 'ios':
        window.open(`https://apps.apple.com/jp/app/id6747801226`, '_blank');
        break;
      case 'youtube':
        window.open(`https://www.youtube.com/@jpdoragenai`, '_blank');
        break;
      case 'twi':
        window.open(`https://x.com/jpdoragenai`, '_blank');
        break;
        case 'dc':
          window.open(`https://discord.gg/yMbEwNxhs7`, '_blank');
          break;

    }
    
  },


}



// WEBPACK FOOTER //
// ./src/commonFunction/common.js